<template>
  <v-toolbar
    flat
    color="primary"
    dark
    class="trip-steps__toolbar"
  >
    <v-toolbar-title>
      <span class="d-none d-sm-inline">Duration </span>
      <strong>{{ tripDuration || '0 days' }}</strong>
    </v-toolbar-title>

    <v-toolbar-title class="ml-4">
      <span class="d-none d-sm-inline">Cost </span>
      <strong>€ {{ trip.cost || 0 }}</strong>
    </v-toolbar-title>

    <v-spacer />

    <dialog-travelers
      v-if="!trip.isNew() && canViewTravelers"
      :trip="trip"
    />

    <vu-file-upload
      v-if="canEdit"
      accept="image/*"
      type="button"
      :storage-path="`/${trip.id}`"
      storage-name="__image"
      :icon="trip.image ? 'mdi-image-edit' : 'mdi-image-plus'"
      :placeholder="trip.image ? 'Change trip image' : 'Add trip image'"
      @uploaded="onImageUploaded"
    />

    <v-menu
      v-if="canEdit"
      :close-on-content-click="false"
    >
      <template #activator="{ on: menu }">
        <v-tooltip left>
          <template #activator="{ on: tooltip }">
            <v-btn
              icon
              v-on="{ ...menu, ...tooltip }"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <span>Other options</span>
        </v-tooltip>
      </template>

      <v-list>
        <v-list-item
          :to="{ name: 'trip-edit', params: { id: tripId } }"
        >
          <v-list-item-avatar>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-avatar>

          <v-list-item-title>
            Edit Trip Name
          </v-list-item-title>
        </v-list-item>

        <confirm-dialog
          v-slot="{ on }"
          @confirm="deleteTrip()"
        >
          <v-list-item v-on="on">
            <v-list-item-avatar>
              <v-icon class="error--text">
                mdi-delete
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-title class="error--text">
              Delete Trip
            </v-list-item-title>
          </v-list-item>
        </confirm-dialog>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { distanceInWordsStrict } from 'date-fns'

import ConfirmDialog from '@/components/ConfirmDialog'
import DialogTravelers from '@/components/DialogTravelers'
import VuFileUpload from '@/components/VuFileUpload'
import TripMixin from '@/components/TripMixin'

export default {
  components: {
    ConfirmDialog,
    DialogTravelers,
    VuFileUpload
  },
  mixins: [ TripMixin ],
  computed: {
    tripDuration () {
      return (this.trip.startDate && this.trip.endDate)
        ? distanceInWordsStrict(this.trip.startDate, this.trip.endDate, { unit: 'd' }) : null
    }
  },
  methods: {
    async deleteTrip () {
      await this.trip.delete()
      this.$router.replace({ name: 'home' })
    },
    async onImageUploaded (error, file, url) {
      if (error) {
        this.$notifyError(`Error saving trip image`)
        return
      }

      this.trip.image = url
      await this.trip.save()

      this.$store.commit('navigation/setToolbar', {
        image: this.trip.image
          ? this.trip.image : require('@/assets/images/trip-placeholder.jpg'),
        title: this.trip.name
      })
    }
  }
}
</script>

<style>

</style>
